import { CampProps } from '../interfaces'

export const formatAddress = (streetAddress: string, city: string, state: string, zip: string) => {
  return `${streetAddress}, ${city}, ${state} ${zip}`
}

export const formatCampAddress = (camp: CampProps) => {
  return `${camp.address}, ${camp.city}, ${camp.state} ${camp.zip}`
}
